import { createContext, useContext } from 'react';

export type GetLangPathParams = Record<string, string | number>;

export type GetLangPathOptions = {
    emptyDefault?: boolean;
};

export type GetLangPath = (
    path?: string,
    params?: GetLangPathParams,
    options?: GetLangPathOptions,
) => string;

export type LangLocaleOption = {
    value: string;
    name: string;
    fullName: string;
};

export type LangDictionary = {
    [key: string]: string | LangDictionary;
};

export type LangContextValue = {
    availableCountries: unknown[];
    availableLocales: LangLocaleOption[];
    getLangPath: GetLangPath;
    locale: string | null;
    setLocale: (locale: string) => void;
    setLang: (locale: string) => void;
    lang: LangDictionary | null;
};

export const LangProviderContext = createContext<LangContextValue | null>(null);

export function useLangContext(): LangContextValue {
    const context = useContext(LangProviderContext);
    if (!context) {
        throw new Error('LangContext cannot be used outside the LangContext provider');
    }
    return context;
}
